<template>
    <div class="app">
        <ul class="survey-info">
           <li>
                <span class="left">就诊医院</span>
                <span class="right">{{medicalInfo.hospitalName}}</span>
            </li>
            <li>
                 <span class="left">就诊科室</span>
                 <span class="right">{{medicalInfo.deptName}}</span>
             </li>
             <li>
                  <span class="left">就诊时间</span>
                  <span class="right">{{evaluateTime}}</span>
              </li>
        </ul>
        <div class="survey-name">您本次对我院提供的就医服务是否满意？</div>
        <ul class="survey-res">
            <li v-for="(item,index) in level" @click="choose(index)">
                <img :src="item.activeSrc" v-if="current==index" width="100%">
                <img :src="item.src" v-if="current !==index" width="100%">
            </li>
        </ul>
        <div style="background: #fff;" class="confirm" v-if="!isSubmit">
            <textarea id="input-content" class="input-area" v-if="!isSubmit" @input="descInput" v-model="desc" maxlength="20" placeholder="请对医院的服务做出评价"></textarea>
            <div class="input-area-tips" v-if="!isSubmit">{{txtVal}}/20</div>
        </div>
        <div class="reason" v-if="isSubmit && desc !== '' ">
            您的理由：{{desc}}
        </div>
        <div class="ok-wrap" v-if="!isSubmit">
            <button id="feedback-submit" class="btn-ok" @click="submitEvaluate">提交</button>
        </div>
        <tips v-model="showTips">
            <span slot="title" style="color: white">温馨提示</span>
            <div slot="list" class="tip-content">{{tips}}</div>
        </tips>
   </div>
</template>

<script>
    import surveyService from 'survey.service'
    import tips from "Tips"
    export default{
        components: {
            tips
        },
        data() {
            return {
                tips:'',
                medicalInfo: {},
                level: [{
                    title: '满意',
                    src: require('../../../static/img/btn-satisfaction-3.png'),
                    activeSrc: require('../../../static/img/btn-satisfaction-3-b.png'),
                    degree:'1',
                },{
                    title: '一般',
                    src: require('../../../static/img/btn-satisfaction-2.png'),
                    activeSrc: require('../../../static/img/btn-satisfaction-2-b.png'),
                    degree:'2',
                },{
                    title: '不满意',
                    src: require('../../../static/img/btn-satisfaction-1.png'),
                    activeSrc: require('../../../static/img/btn-satisfaction-1-b.png'),
                    degree:'3',
                }],
                satisfaction:'',
                current:0,
                txtVal:0,
                desc:'',
                isSubmit:false,
                evaluateTime:'',
                showTips: false,
                weekday:['周日','周一','周二','周三','周四','周五','周六'],
                currentTime:'',
            }
        },
        mounted() {
            this.refresh()
        },
        methods: {
            refresh() {
                this.getTime()
                this.medicalInfo = this.$router.currentRoute.query
                if(this.medicalInfo.evaluateTime) {
                    if(this.medicalInfo.evaluateTime.indexOf('.') != -1){
                        this.medicalInfo.evaluateTime = this.medicalInfo.evaluateTime.replace(/\./g,'-')
                    }
                    let dateObject = new Date(this.medicalInfo.evaluateTime.replace(/-/g,'/'))
                    let week = dateObject.getDay()
                    this.evaluateTime = dateObject.format('yyyy/MM/dd hh:mm').split(' ').join(this.weekday[week] + ' ')
                    if(this.medicalInfo.evaluateTime == null) {
                        this.evaluateTime = ''
                    }
                    this.loadEvaluation()
                }
            },
            choose(index) {
                if(!this.isSubmit) {
                    this.current = index
                }
            },
            submitEvaluate() {
                if(this.current === 2 && this.desc === "") {
                    this.tips = '请输入您对医院服务的评价'
                    this.showTips = true
                    return
                }
                if(this.satisfaction !== ""){
                    this.tips = '您已评价过,无法重复评价'
                    this.showTips = true
                    return
                }
                surveyService.submitEvaluation({
                    creatTime:this.currentTime,
                    deptId:this.medicalInfo.deptId,
                    deptName:this.medicalInfo.deptName,
                    doctId:this.medicalInfo.doctId,
                    doctName:this.medicalInfo.doctName,
                    patientName:this.medicalInfo.patientName,
                    visitId:this.medicalInfo.visitId,
                    patientId:this.medicalInfo.patientId,
                    degree:this.level[this.current].degree,
                    evaluation:this.desc,
                }).then((res) => {
                    if(res.resultCode == this.constant.RESULT_SUCCESS){
                        this.isSubmit = true
                        this.tips = '您的评价已提交,感谢您的配合与支持'
                        this.showTips = true
                    }else{
                        this.tips = '登记失败,请重新登记'
                        this.showTips = true
                        return
                    }
                })
            },
            descInput() {
                this.txtVal = this.desc.length
            },
            loadEvaluation() {
                surveyService.queryEvaluation({
                    visitId:this.medicalInfo.visitId,
                    patientId:this.medicalInfo.patientId
                }).then((res) =>{
                    if(res.data !== '') {
                        this.satisfaction = res.data.degree
                        this.tips = '您已评价过,无法重复评价'
                        this.showTips = true
                        return
                    }
                })
            },
            //获取当前时间
            getTime() {
                let date = new Date()
                let currentTime = date.format('yyyy-MM-dd hh:mm:ss')
                this.currentTime = currentTime
            }
        }
    }
</script>
<style lang="scss">
    .app {
        background-color: #EFF3F6;
        padding-bottom:3.75rem;
        .message-pop-content{
            width: 13.0rem;
            left: 50%;
            margin-left: -6.5rem;
            height: 8.0rem;
            border-radius: 0.15rem;
        }
        .message-box-title {
            border-radius: 0.15rem 0.15rem 0 0;
        }
        .message-scroll{
            border-radius:  0 0 0.15rem 0.15rem;
        }
        .popup-message-box {
            background-color: rgba(0, 0, 0, 0.5);
        }
        .tip-content {
            text-align: center;
            padding: 1.75rem 0;
        }
    }
</style>
<style lang="scss" scoped>
    body {
        position: relative;
        .app {
            background-color: #EFF3F6;
            .survey-info {
                margin: 0.75rem 0.5rem;
                background-color: #fff;
                border-radius: 0.25rem;
                li {
                    height: 2.125rem;
                    line-height: 2.125rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 0.85rem;
                    border-bottom: 0.05rem solid #F0F1F5;
                    &:last-child {
                        border:none;
                    }
                    .left {
                        color:#A2A2A2;
                    }
                }
            }
            .survey-name {
                text-align: center;
                margin: 1.0rem 0.5rem;
                height: 2.0rem;
                line-height: 2.0rem;
                border-bottom: 0.05rem solid #d7d7d7;
                color:#818181;
            }
            .survey-res {
                display: flex;
                justify-content: space-between;
                margin:0 0.5rem;
                letter-spacing:2px;
                li{
                    width:5.25rem;
                    height:auto;
                    border-radius: 0.25rem;
                    text-align:center;
                    margin-right:1.125rem;

                    &:last-child {
                        margin: 0;
                    }
                }
                
            }
            .confirm {
                margin: 1.25rem 0.5rem;
                height: 8.95rem;
                border-radius:0.25rem;
                overflow: hidden;
                .input-area {
                    padding: 0.75rem 0.75rem;
                    letter-spacing:1px;
                    height: 7.0rem;
                }
                .input-area-tips {
                    padding:0.5rem 0.5rem;
                    letter-spacing:1px;
                    color:#cccccc;
                }
            }
            .reason {
                margin:1.25rem 0.5rem;
            }
            .ok-wrap{
                position: fixed;
                height: 2.5rem;
                bottom: 0.5rem;
                left: 0.5rem;
                right: 0.5rem;
                .btn-ok {
                    letter-spacing:1px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// Survey.vue?5ec653b9